import { axiosInstance } from '@/services/axios-instance';
import type { IEventRequest } from '@/services/events/types';

export const postEvent = async (data: IEventRequest): Promise<void> => {
  return axiosInstance.post('/events', data);
};
